import { render, staticRenderFns } from "./viewFileChats.vue?vue&type=template&id=5c22c0ac&scoped=true&"
import script from "./viewFileChats.vue?vue&type=script&lang=js&"
export * from "./viewFileChats.vue?vue&type=script&lang=js&"
import style0 from "./viewFileChats.vue?vue&type=style&index=0&id=5c22c0ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c22c0ac",
  null
  
)

export default component.exports